export const pageInDuration = 1000;
export const pageOutDuration = 1000;
export const pageIntroDuration = 2500;